import Image from "next/image";

/**
 * Shown when CMS/GraphQL content cannot be loaded — avoids a blank shell
 * (header/footer with empty main) during outages or misconfiguration.
 */
export function MaintenanceNotice({
  title = "We'll be back soon",
  message = "The Royal Adelaide Show website is temporarily unavailable while we make some updates. Please try again shortly.",
}) {
  return (
    <main
      className="flex flex-col items-center justify-center min-h-[70dvh] px-6 py-16 text-center bg-brand-wool"
      role="status"
      aria-live="polite"
    >
      <div className="flex flex-col items-center max-w-lg gap-6">
        <div className="w-14 h-14 sm:w-16 sm:h-16" aria-hidden>
          <Image
            src="/brand/ras-rose.svg"
            alt=""
            width={64}
            height={64}
            className="object-contain w-full h-full"
            priority
          />
        </div>
        <div className="space-y-3">
          <h1 className="font-heading level-2 text-brand-espresso">{title}</h1>
          <p className="font-body text-brand-espresso/80 text-base sm:text-lg leading-relaxed">
            {message}
          </p>
        </div>
        <p className="font-body text-sm text-brand-espresso/50">
          If this keeps happening, please check back in a few minutes.
        </p>
      </div>
    </main>
  );
}
